<template>
  <a-modal
    :title="'添加拜访记录'"
    okText="确定"
    @ok="save"
    v-model="visible"
    :width="450"
    destroyOnClose
    wrapClassName="recommend-modal"
  >
    <a-form :form="form">
      <h3 :style="{ marginTop: '20px' }">请填写拜访记录：</h3>
      <a-form-item>
        <a-textarea
          placeholder="请在此填写拜访记录"
          :rows="4"
          v-decorator="[
            'reason',
            { rules: [{ required: true, message: '请在此填写拜访记录' }] }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Api from "@/api";
export default {
  name: "EditMessage",
  props: {
    callback: {
      type: Function
    }
  },
  created() {},
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      company: ""
    };
  },
  watch: {},
  methods: {
    save() {
      console.log("添加");
      this.form.validateFields((err, values) => {
        if (!err) {
          let params = {
            hr_company_id: this.company.id,
            content: values.reason
          };
          console.log(params);
          Api.client.editLook(params).then(res => {
            console.log(res);
            if (res) {
              this.$message.success("添加成功");
              this.callback && this.callback();
              this.visible = false;
            } else {
              this.$message.error("添加失败");
            }
          });
        }
      });
    },

    show(item) {
      this.visible = true;
      console.log(item);
      this.company = item;
      this.$nextTick().then(() => {
        // this.form.setFieldsValue({
        //   company : this.record.name,
        // });
      });
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss"></style>
